export default "__VITE_ASSET__DWsMK1G3__"